<template>
  <div class="json-mapper-component">
    <div class="content-wrapper">
      <div
        class="object-element-wrapper"
        v-for="(objectElement, objectIndex) in objectValues"
        :key="objectIndex"
      >
        <div class="left-content-form">
          <input
            type="text"
            v-model="objectElement.key"
            :class="{
              'invalid-input': objectElement.keyError,
            }"
            @input="onInputValue(objectElement.id, 'key')"
            :disabled="!isUserHasAccess"
          />
          <div v-if="getDropdownItems.length">
            <generalDropdown :disabled="!isUserHasAccess">
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="item in getDropdownItems"
                  :key="item.label"
                  @click="
                    onSelectInputElement('key', item.name, objectElement.id)
                  "
                >
                  {{ item.name }}
                </b-dropdown-item>
              </template>
            </generalDropdown>
          </div>
        </div>

        <div class="right-content-form">
          <input
            type="text"
            v-model="objectElement.value"
            :class="{
              'invalid-input': objectElement.valueError,
            }"
            @input="onInputValue(objectElement.id, 'value')"
            :disabled="!isUserHasAccess"
          />
          <div v-if="getDropdownItems.length">
            <generalDropdown :disabled="!isUserHasAccess">
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="item in getDropdownItems"
                  :key="item.label"
                  @click="
                    onSelectInputElement('value', item.name, objectElement.id)
                  "
                >
                  {{ item.name }}
                </b-dropdown-item>
              </template>
            </generalDropdown>
          </div>
          <div
            v-if="isUserHasAccess"
            @click="onRemoveObjectElement(objectIndex)"
            class="remove-element"
            :class="{ space: !getDropdownItems.length }"
          >
            <i class="far fa-trash-alt"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import generalDropdown from '../core/general-dropdown.vue';
import {
  getInputPlaceholderList,
  getApiEndpointVersion,
  LATEST_FLOW_RUNNER_VERSION,
} from '@/utils/helpers.js';

export default {
  props: {
    task: {
      type: Object,
    },
    objectValues: {
      type: Array,
    },
    isUserHasAccess: {
      type: Boolean,
      required: false,
      default: true,
    },
    flowRunnerEndpoint: {
      type: String,
    },
  },

  methods: {
    onSelectInputElement(type, item, elementId) {
      const objectToUpdate = this.objectValues.find(
        (objectElement) => objectElement.id == elementId
      );
      if (item.includes(':')) {
        objectToUpdate[type] = `{${item}}`;
      } else {
        const selectedObject = this.getSelectedInput(item);

        objectToUpdate[type] = `{${selectedObject.name}}`;
      }
      this.onInputValue(elementId, type);
    },

    onRemoveObjectElement(index) {
      if (this.isUserHasAccess) {
        this.$emit('onRemoveObjectElement', index);
      }
    },

    getSelectedInput(item) {
      return this.task.input.find((input) => input.label === item);
    },

    getAllKeyNames(id) {
      return this.objectValues
        .filter((objectElement) => objectElement.id !== id)
        .map((objectElement) => objectElement.key);
    },

    isValidInput(inputValue) {
      const regex = /[,.;!?'"*` ]/g;
      return !regex.test(inputValue);
    },

    onInputValue(objectElementId, type) {
      if (type === 'key') {
        this.objectValues.forEach((obj) => {
          if (obj.key) {
            obj.keyError =
              this.getAllKeyNames(obj.id).includes(obj.key) ||
              !this.isValidInput(obj.key)
                ? true
                : false;
          } else if (!obj.key && obj.keyError && obj.id === objectElementId) {
            obj.keyError = false;
          }
        });
      } else if (type === 'value') {
        const onFocusObejctElement = this.objectValues.find(
          (obj) => obj.id === objectElementId
        );

        onFocusObejctElement.valueError =
          onFocusObejctElement.value &&
          !this.isValidInput(onFocusObejctElement.value);
      }
    },
  },
  computed: {
    getDropdownItems() {
      const apiVersion =
        getApiEndpointVersion(this.flowRunnerEndpoint) ||
        LATEST_FLOW_RUNNER_VERSION;
      return getInputPlaceholderList(this.task.input, apiVersion);
    },
  },
  components: {
    generalDropdown,
  },
};
</script>

<style scoped>
.json-mapper-component .content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: max-content;
  margin-inline: auto;
}
.json-mapper-component .object-element-wrapper {
  display: flex;
  gap: 50px;
  align-items: center;
}

.json-mapper-component .right-content-form,
.json-mapper-component .left-content-form {
  display: flex;
  align-items: center;
}

.json-mapper-component .right-content-form input,
.json-mapper-component .left-content-form input {
  border: 1px solid #dee3e9;
  border-radius: 0.375rem;
  padding: 10px 15px;
  cursor: text;
  height: auto;
}

.json-mapper-component .remove-element {
  font-size: 18px;
  cursor: pointer;
  margin-left: 8px;
}
.json-mapper-component .remove-element.space {
  margin-left: 15px;
}
.json-mapper-component .invalid-input {
  background-color: #ff050578;
}
.json-mapper-component ::v-deep .dropdown-menu {
  max-height: 280px;
}
</style>
